import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getKnmListFilterFilters = (state: IRootState) => state.knmListFilter.filters;
export const getKnmListFilterCurrentFilter = (state: IRootState) => state.knmListFilter.current;
export const getKnmListFilterIsFilterOn = (state: IRootState) => state.knmListFilter.isFilterOn;
export const getKnmListFilterCurrentId = (state: IRootState) => state.knmListFilter.currentId;
export const getKnmListFilterPlanNum = (state: IRootState) => state.knmListFilter.planNum;
export const getKnmListCurrentControlOrganizations = (state: IRootState) =>
  state.knmListFilter.currentControlOrganizations;
export const getKnmListCurrentFederalLaws = (state: IRootState) => state.knmListFilter.federalLaws;
